const options =
  'location=yes,closebuttoncaption=◀︎ Retour,closebuttoncolor=#000000,toolbarcolor=#ffffff,hidenavigationbuttons=yes';
export const InAppBrowserSetting = {
  iosOptions: `${options},toolbarposition=top,fullscreen=yes`,
  androidOptions: `${options},lefttoright=yes,hideurlbar=yes,zoom=no`,
};
